import { HomeMainActions } from '@/common/components/home';
<template>
  <div>
    <header class="pt-0 pl-5 pr-5" :class="theme">
      <b-row class="d-flex text-light py-sm-3 px-lg-5 header-container m-auto">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex flex-wrap justify-content-start align-items-center w-75">
            <b-skeleton width="120px" height="30px" class="mr-4"></b-skeleton>
            <div class="d-flex justify-content-star align-items-center mr-auto">
              <b-skeleton
                width="100px"
                height="34px"
                class=" rounded-pill px-3 py-2 text-capitalize d-flex align-items-center mr-4"
              >
              </b-skeleton>
              <b-skeleton width="30px" height="20px"></b-skeleton>
            </div>
            <b-container>
              <b-row align-h="start" class="pt-5">
                <b-col
                  cols="12"
                  v-for="(motivationalLine, index) in motivationalLines"
                  :key="index"
                >
                  <b-skeleton :width="motivationalLine.width"></b-skeleton>
                </b-col>
              </b-row>
            </b-container>
          </div>

          <div class=" d-flex flex-row">
            <div class="avatarIconContainerChild">
              <b-skeleton type="avatar" width="100%" height="100%"></b-skeleton>
              <b-skeleton
                type="avatar"
                width="50px"
                height="50px"
                class="bg-coin-absolute"
              ></b-skeleton>
            </div>
          </div>
        </div>
      </b-row>
    </header>
    <section class="mainSection mx-auto pb-2">
      <home-main-actions-skeleton></home-main-actions-skeleton>
      <home-main-tasks-skeleton></home-main-tasks-skeleton>
      <home-second-actions-skeleton></home-second-actions-skeleton>
    </section>
  </div>
</template>

<script>
import {
  HomeMainActionsSkeleton,
  HomeMainTasksSkeleton,
  HomeSecondActionsSkeleton,
} from '@/common/components/child/skeletons';

export default {
  components: { HomeMainActionsSkeleton, HomeMainTasksSkeleton, HomeSecondActionsSkeleton },
  props: {
    theme: String,
  },
  data() {
    return {
      motivationalLines: [{ width: '100%' }, { width: '50%' }],
    };
  },
};
</script>

<style lang="scss" scoped>
.avatarIconContainerChild {
  background-color: white;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.9;
}

.mainSection {
  width: 95%;
  max-width: 1000px;
  padding: 0 2rem;
  margin: -3rem auto 0 auto;
}

.shadow-radius {
  border-radius: 10px;
  box-shadow: var(--atm-shadow);
}
</style>
